import { ArticleBatchDto } from './article-batch.dto';
import { ArticleDto } from './article.dto';
import { PackagingTypeDto } from './packaging-type.dto';
import { RawMaterialDto } from './rawMaterial.dto';

export class PackagingDto {
    id?: number;
    externalId?: number;
    externalBatchNumber?: string;
    batchNumber?: string;
    packagingTypeId!: number;
    packagingType?: PackagingTypeDto;
    articleId!: number;
    article?: ArticleDto;
    articleBatchId?: number;
    articleBatch?: ArticleBatchDto;
    quantity?: number;
    axuliaryQuantity?: number;
    rawMaterials?: RawMaterialDto[];
    hasRawMaterials?: boolean;
    parentPackaging?: PackagingDto[];
    childPackaging?: PackagingDto[];
    consumed?: boolean;
    labelPrinted?: boolean;
}
